if (!customElements.get('card-product')) {
  class CardProduct extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.quickviewButton = this.querySelector('.js-quickview-button');
      if (this.quickviewButton) {
        this.quickviewButton.addEventListener('click', (event) =>
          this.onQuickviewButtonClick(event),
        );
        this.quickviewPopup = document.querySelector('#quickview-popup');
        this.quickviewPopupContainer = this.quickviewPopup.querySelector(
          '#quickview-popup-container',
        );
      }
    }

    async onQuickviewButtonClick(event) {
      event.preventDefault();
      const url = this.dataset.productUrl + '?section_id=main-product';
      try {
        const data = await (await fetch(url)).text();

        const html = new DOMParser().parseFromString(data, 'text/html');
        const newProductMarkup = html.querySelector('.product');

        this.quickviewPopupContainer.innerHTML = '';
        this.quickviewPopupContainer.appendChild(newProductMarkup);
        this.quickviewPopup.showModal();
        setTimeout(() => {
          document.activeElement?.blur();
          this.quickviewPopup.scrollTo({ top: 0 });
        }, 0);
      } catch (error) {
        console.error(error);
      }
    }
  }
  customElements.define('card-product', CardProduct);
}
